<template lang='pug'>
  #app
    transition( mode='out-in' )
      router-view
</template>

<script>
  import TopNav from '@/components/top-nav'

  export default {
    components: {
      TopNav
    }
  }
</script>

<style lang="stylus">
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:ital,wght@0,300;0,700;1,300&display=swap')
  @import 'https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css'
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@320&family=Yellowtail&display=swap&family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet')

  :root
    --shadow-panel 0 0 16px 0 rgba( 40 80 120 .75 )
    --shadow-box 0 0 12px 0 rgba( 0 0 0 .2 )
    --shadow-box-shallow 0 0 8px 0 rgba( 0 0 0 .1 )
    --shadow-card 0 0 8px 0 rgba( 125 125 125 .1 )
    --shadow-card-hover 0 0 12px 0 rgba( 175 150 125 .64 )
    --shadow-border   0 1px 1px 0 rgba( 255 255 255 1)
    --shadow-text  0 0 1px 2px rgba( 255 255 255 1 )
    --text-shadow-rev 0 -1px 2px rgba( 0,0,0,.2 )
    --shadow-text-rev 0 -1px 2px rgba( 0,0,0,.2 )
    --orange rgb(250,225,200)
    --gray rgb(80 88 88)
    --light  rgb(240,240,240)
    --dark   rgb(80,84,88)
    --darker rgb(40 42 48)
    --color-bg rgb(240,240,240)
    --height-nav 64px

    --bg-body linear-gradient(
      135deg,
      rgba(80,90,100,1),
      rgba(150,160,165,1)
    )

  ::placeholder
    color inherit

  ::-webkit-scrollbar
    width 5px

  ::-webkit-scrollbar-track
    background-color rgba(240,240,240,.25)

  ::-webkit-scrollbar-thumb
    background-color rgba(25,50,60,.75)

  @keyframes logo-spinner {
    0% {
      transform rotate(0deg)
      top -3em
      opacity 0
    }
    80% {
      transform rotate(990deg)
      opacity .5
    }
    88% {
      top .3em
      opacity 1
    }
    96% {
      top .15em
      opacity .5
    }
    100% {
      top .2em
      opacity 1
    }
  }

  @keyframes rotate-y {
    0% {
      transform rotateY(0deg)
    }

    100% {
      transform rotateY(1440deg)
    }
  }

  @keyframes slide-in-from-top {
    0% {
      top -100vh
    }

    80% {
      top 32px
    }
    88% {
      top -24px
    }
    96% {
      top 16px
    }

    100% {
      top 0
    }
  }

  @keyframes text-slider {
    0% {
      opacity 0
      left 100vh
    }
    80% {
      opacity .5
      left 0
    }
    88% {
      opacity 1
    }
    96% {
      opacity .75
    }
    100% {
      opacity 1
    }
  }

  @keyframes fade-in {
    0% {
      transform scale(3)
      opacity 0
    }
    80% {
      opacity .5
      transform scale(1.1)
    }
    88% {
      opacity 1
      transform scale(1)
    }
    96% {
      opacity .75
      transform scale(1.05)
    }
    100% {
      transform scale(1)
      opacity 1
    }
  }

  body
    font-family Roboto
    font-weight 300
    color rgb( 64 64 64 )
    background repeating-linear-gradient(
      -45deg,
      rgb( 220 220 220 ),
      rgb( 220 220 220 ) 1px,
      rgb( 228 228 228 ) 1px,
      rgb( 228 228 228 ) 2px
    )

  a
    text-decoration: none
    color inherit

  h1
    font-family Yellowtail
    font-size 2.4em
  h2
    font-family Oswald
    font-size 1.6em
  h3
    // color rgb( 0 100 125 )

  input, textarea, select, button
    outline none
    border 0
    background 0

  button
    cursor pointer
    
  .v-enter-active,
  .v-leave-active {
    transition all 320ms
    transition-timing-function ease
  }

  .v-enter,
  .v-leave-active {
    transform translateX(-100vw)
  }
</style>
